import React, { Component } from "react";

class ChaptersUpSVG extends React.Component {
  render() {
    return (
      <svg
        className={"svg-container " + this.props.svgClassName}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
      >
        <path
          className="svg"
          d="M9.7,10.6c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S9.7,9,9.7,10.6z M6.7,5.6c-2.8,0-5,2.2-5,5s5,10.8,5,10.8
	s5-7.9,5-10.8S9.4,5.6,6.7,5.6z M20.3,5.7c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S20.3,4,20.3,5.7z M17.3,0.6c-2.8,0-5,2.2-5,5
	s5,10.8,5,10.8s5-8,5-10.8S20.1,0.6,17.3,0.6z M20.4,18.5h-8.9c-0.1,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h8.9c1.7,0,3.1-1.4,3.1-3.1
	c0-1.5-1.1-2.8-2.6-3c-0.1,0-0.2-0.2-0.2-0.3c0-0.1,0.1-0.2,0.3-0.2c1.7,0.3,3,1.8,3,3.5C24,16.9,22.4,18.5,20.4,18.5z M10.4,18.5
	h-0.2c-0.1,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h0.2c0.1,0,0.3,0.1,0.3,0.3S10.6,18.5,10.4,18.5z M13.8,23.4h-0.2
	c-0.1,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h0.2c0.1,0,0.3,0.1,0.3,0.3S13.9,23.4,13.8,23.4z M12.5,23.4H3.6c-2,0-3.6-1.6-3.6-3.6
	c0-1.7,1.2-3.2,3-3.5c0.1,0,0.3,0.1,0.3,0.2c0,0.1-0.1,0.3-0.2,0.3c-1.5,0.3-2.6,1.5-2.6,3c0,1.7,1.4,3.1,3.1,3.1h8.9
	c0.1,0,0.3,0.1,0.3,0.3S12.6,23.4,12.5,23.4z"
        />
      </svg>
    );
  }
}

export default ChaptersUpSVG;



// WEBPACK FOOTER //
// ./src/svg/ChaptersUpSVG.jsx